import { render, staticRenderFns } from "./HistoricoBeneficiarioPainel.vue?vue&type=template&id=360eaf28&scoped=true"
import script from "./HistoricoBeneficiarioPainel.vue?vue&type=script&lang=js"
export * from "./HistoricoBeneficiarioPainel.vue?vue&type=script&lang=js"
import style0 from "./HistoricoBeneficiarioPainel.vue?vue&type=style&index=0&id=360eaf28&prod&lang=scss"
import style1 from "./HistoricoBeneficiarioPainel.vue?vue&type=style&index=1&id=360eaf28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360eaf28",
  null
  
)

export default component.exports